export default __webpack_public_path__ + "static/media/arm.4bf4c3d6.mp4";